import {
  HttpContext,
  HttpContextToken,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from '@mkp/shared/util-app-config';
import { isHttpErrorResponse } from '@mkp/shared/util-format';
import { catchError, throwError } from 'rxjs';

const { routes } = AppConfig;

// when the token expires we get a 403
// however we don't want to redirect to /forbidden in this case because the token is automatically refreshed
// also there is no way to make this call optional because it is done from within the auth0 package
const OPTIONAL_ROUTES = [`oauth/token`];

const OPTIONAL_CONTEXT = new HttpContextToken<boolean>(() => false);
export const getOptionalContext = (httpContext?: HttpContext) =>
  (httpContext ?? new HttpContext()).set(OPTIONAL_CONTEXT, true);

const is403 = (error: unknown): boolean => isHttpErrorResponse(error) && error.status === 403;
const is500 = (error: unknown): boolean => isHttpErrorResponse(error) && error.status === 500;
const hasOptionalContext = (req: HttpRequest<unknown>) => req.context.get(OPTIONAL_CONTEXT);
const isOptionalRoute = (req: HttpRequest<unknown>): boolean =>
  !!OPTIONAL_ROUTES.find((exceptionUrl) => req.url.includes(exceptionUrl));
const isRequiredCall = (req: HttpRequest<unknown>): boolean =>
  !hasOptionalContext(req) && !isOptionalRoute(req);

export const optionalApiInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (is403(error) && isRequiredCall(req)) {
        router.navigate([routes.error403]);
      }
      if (is500(error) && isRequiredCall(req)) {
        router.navigate([routes.error500]);
      }
      return throwError(() => error);
    })
  );
};
